import {connect} from 'react-redux';

import {toggleContactMergeInfoBoxAction} from '../../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getIsContactMergeInfoBoxExpanded} from '../../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {makeGetMergeContactsSidePanelStatus} from '../../../../../../../../src/store/panels/contacts/contactsManager/sidePanel/contactsManagerMergeContactsSelectors';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {MergeContactsSidePanelHeader} from './mergeContactsSidePanelHeader';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  status: makeGetMergeContactsSidePanelStatus(),
  isInfoBoxVisible: getIsContactMergeInfoBoxExpanded,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onToggleInfoBox: toggleContactMergeInfoBoxAction,
}));

export const MergeContactsSidePanelHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MergeContactsSidePanelHeader);
